import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(() => api.get("/content").then(({ data }) => setContent(data)).catch(() => {}), []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <SiteContext.Provider value={{ content, refresh }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
